<form [formGroup]="form">
  <div class="email">
    <glxy-form-field [bottomSpacing]="false" [suffixText]="'@' + (domain$ | async)">
      <glxy-label>{{ 'COMMON.EMAIL_ADDRESS' | translate }}</glxy-label>
      <input type="text" matInput [formControlName]="formControlNameString" autocomplete="off" />
      @if (form.get(formControlNameString).invalid && form.touched) {
        <glxy-error>
          {{ 'EMAIL_USERNAME_INPUT.EMAIL_REQUIRED' | translate }}
        </glxy-error>
      }
    </glxy-form-field>
    @if ((isDefaultDomain$ | async) === false) {
      <mat-icon
        [glxyTooltip]="'EMAIL_USERNAME_INPUT.USE_DIFFERENT_DOMAIN' | translate"
        (click)="changeDomain()"
        >
        edit
      </mat-icon>
    }
  </div>
</form>
